<template>
  <div class="col-span-6" v-if="!oneoption">
    <label v-if="field.required" class="block 2xl:text-sm sm:text-xl font-medium leading-5 text-gray-700">
      {{field.label}}<span class="text-red-700">*</span>:
    </label>
    <label v-else class="block 2xl:text-sm sm:text-xl font-medium leading-5 text-gray-700">
      {{field.label}}:
    </label>
    <select @change="$parent.updateValue(field.key, $event.target.value)" :disabled="isDisabled" class="mt-1 block w-full pl-3 pr-10 py-2 2xl:text-sm sm:text-xl border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 rounded-md disabled:bg-gray-100 disabled:cursor-not-allowed">
      <option v-if="options.length > 1" value="">Seleccione opción</option>
      <template v-for="option in options">
        <option v-if="optionstype === 'dynamic'" v-bind:key="option[field.options_value]" v-bind:value="option[field.options_value]" v-bind:selected="option[field.options_value] === formdata[field.key]">{{option[field.options_label]}}</option>
        <option v-if="optionstype === 'fixed'" v-bind:key="option" v-bind:value="option">{{option}}</option>
      </template>
    </select>
    <p v-if="validation !== undefined" class="mt-2 lg:text-base sm:text-lg text-red-600" id="email-error">* {{validation.msg}}</p>
  </div>
</template>
<script>
export default {
  name: 'select-field',
  data() {
    return {
      options: [],
      dependentdata: {},
      optionstype: 'dynamic',
      oneoption: false
    }
  },
  computed: {
    isDisabled() {
      // Disable if field has a dependency and the parent field is empty
      if (this.field.depends !== '' && this.field.depends !== undefined) {
        return !this.formdata[this.field.depends] || this.formdata[this.field.depends] === ''
      }
      return false
    }
  },
  props: {
    field: {
      type: Object,
      required: true
    },
    params: {
      type: Object,
      required: false
    },
    formdata: {
      type: Object,
      required: true
    },
    validation: {
      type: Object,
      required: false
    }
  },
  created() {
    this.checkDepends()
  },
  watch: {
    formdata: {
      deep: true,
      handler: async function(newVal) {
        console.log('change!', newVal)
        if (this.field.depends !== '' && this.field.depends !== undefined) {
          // Check if parent field is empty
          if (!newVal[this.field.depends] || newVal[this.field.depends] === '') {
            // Clear options and reset to empty state
            this.options = []
            this.dependentdata[this.field.depends] = ''
            return
          }
          
          if ( typeof this.dependentdata[this.field.depends] === 'object'){
            if (JSON.stringify(this.dependentdata[this.field.depends]) !== JSON.stringify(newVal[this.field.depends])) {
              this.dependentdata[this.field.depends] = JSON.parse(JSON.stringify(newVal[this.field.depends]))
              await this.getValues() // XXX: esto no existe
            }
          } else {
            if (this.dependentdata[this.field.depends] !== newVal[this.field.depends]) {
              this.dependentdata[this.field.depends] = JSON.parse(JSON.stringify(newVal[this.field.depends]))
              await this.fetchOptions()
            }
          }
        }
      }
    },
    field: {
      deep: true,
      handler: function(newVal) {
        console.log('field', newVal)
        this.checkDepends()
      }
    },
  },
  methods: {
    checkDepends() {
      console.log('checkDepends', this.field)
      if (this.field.options.length > 0) {
        this.optionstype = 'fixed'
        this.options = this.field.options
      } else {
        if (this.field.depends === undefined || this.field.depends === "") {
          this.fetchOptions()
        } else if (this.field.depends && this.formdata[this.field.depends] && this.formdata[this.field.depends] !== '') {
          // Only fetch options if parent has a value
          this.fetchOptions()
        }
      }
    },
    async fetchOptions() {
      console.log('fetchOptions')
      let config = {
        params: {
          key: this.field.options_key,
          id: this.$route.params.record,
          ...this.$store.state.data,
          ...this.formdata,
          ...this.dependentdata
        }
      }
      const response = await this.$http.get(this.field.uri, config)
      this.options = response.data
      if (this.options.length === 1) {
        this.$parent.updateValue(this.field.key, this.options[0][this.field.options_value])
        if (this.field.hideonautoselect === true) {
          this.oneoption = true
        }
      }
    }
  }
}
</script>
